import { EntityType, IdName, VehicleDraft, Vehicle, Source, ServiceAccount, Division, Key } from "../../../../../models";
import { prepareVehicleDraft } from "../../../../utils/draft";

import { EditStore } from "../../EditCreate/EditStore";
import { EditVehicleState } from './EditVehicleState';
import { names, Update } from "./EditVehicleActions";
import { assertArray, assertNumber, assertTrue, assertString } from "../../../../utils/assert/index";
import { Timezone } from "../../../../../rest/Misc/timezones";
import { names as editCreateNames } from "../../../../actions/EditCreateEntityActions";
import { Forest, selfAndAncestors } from "../../../../../utils/Forest";
import { removeUndefined } from "../../../../../utils/removeUndefined";

let session: number = 0;
export class EditVehicleStore extends EditStore<VehicleDraft, EditVehicleState>
{
    isIsolatedPremise: boolean;
    constructor() {
        super();
        this.state = this.getDefaultStateFor(null);

        this.register<Update>(names.COMPOUND_UPDATE, e => {
            const update = e.payload;
            const { DivisionId, ServiceAccountId, GeotabId, GeotabTitle, ...rest } = update;

            return {...this.state, ...rest, draft: this.getDraft(removeUndefined({ DivisionId, ServiceAccountId, GeotabId, GeotabTitle }))};
        });

        this.register<Source>(names.SET_SOURCE, e => this.draft({ SourceId: e.payload }));
        this.register<string>(names.SET_BOX_ID, e => this.draft({ BoxId: e.payload }));
        this.register<string[]>(names.SET_ALL_TAGS, e => this.field({ allTags: e.payload }));
        
        this.register<Key>(names.SET_TIMEZONE, e => this.draft({ TimezoneId: e.payload }));
        this.register<string>(names.SET_DISPLAY, e => this.setDisplay(e.payload));
        this.register<string[]>(names.SET_TAGS, e => this.setTags(e.payload));

        this.register(editCreateNames.REJECT_DRAFT, e => {
            if(e.meta === EntityType.Vehicle) {
                return this.getDefaultStateFor(null);;
            }
        });
        this.register<Vehicle>(editCreateNames.SET_EDIT_ENTITY, e => {
            if(e.meta === EntityType.Vehicle) {
                return this.getDefaultStateFor(e.payload);
            }
        });
    }

    setDisplay = (display: string): EditVehicleState => {
        assertTrue(display === null || typeof display === 'string');
        return this.draft({ Display: display });
    }

    setTags = (tags: string[]): EditVehicleState => {
        assertArray(tags, 'expect Array of string payload');
        tags.forEach(tag => assertString(tag));
        return this.draft({ Tags: tags });
    }

    private getDefaultStateFor(vehicle: Vehicle): EditVehicleState
    {
        return {
            draft: prepareVehicleDraft(vehicle, this.isIsolatedPremise ? Source.BoxId : Source.BoxId),
            
            // Pay attention to null. Empty array will break UpsertVehicleController
            allServiceAccounts: null, // not empty array!
            filteredServiceAccounts: null,
            allDivisions: null,
            divisionsForest: null,
            
            vehicles: [],
            allTags: [],

            mode: vehicle ? 'edit' : 'create'
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/flux/EditVehicleStore.ts